import React from 'react';
import { useOutletContext } from 'react-router-dom';

import Banner from '../../Components/Banner/Banner';

const Home = () => {
    const { openSignup } = useOutletContext();

    return <Banner onSignUpClick={openSignup} />;
};

export default Home;
